import { inject, Injectable } from '@angular/core';
import { CONFIG_TOKEN } from '@pxl/models/common';
import { InsuranceOfferService, LoginService } from '@pxl/models/contracts';
import {
    InsuranceOfferModel,
    InsuranceOfferResultModel,
    InsuranceOfferService as InsuranceOfferBackendService,
    RequestInsuranceOfferModel,
} from '@pxl/shared/generated';
import { Observable } from 'rxjs';

/**
 * Ticket #55494: reads and requests insurance offers through the backend insurance-offer endpoints.
 *
 * Backend-only communication — the app never sees the insurer API key. The result status of a request decides
 * the outcome (`Created` = success; everything else = unchanged, retriable).
 */
@Injectable({
    providedIn: 'root',
})
export class DefaultInsuranceOfferService implements InsuranceOfferService {
    private readonly backendService = inject(InsuranceOfferBackendService);
    private readonly config = inject(CONFIG_TOKEN);
    private readonly loginService = inject(LoginService);

    public getOffers(patientId: string): Observable<InsuranceOfferModel[]> {
        return this.backendService.getOffers(patientId, this.config.API_VERSION, this.loginService.getToken() ?? '');
    }

    public requestOffer(request: RequestInsuranceOfferModel): Observable<InsuranceOfferResultModel> {
        return this.backendService.requestOffer(request, this.config.API_VERSION, this.loginService.getToken() ?? '');
    }
}
